<ng-container>
  <app-header [isScreenSmall]="isScreenSmall" (sidenavToggle)="sidenav.matSideNav.toggle()">
  </app-header>
  <app-sidenav [isScreenSmall]="isScreenSmall" #sidenav></app-sidenav>
</ng-container>
